import { twMerge } from 'tailwind-merge';
import Title from '@/components/Title';
import { ProfitIcon } from '@/icons';
import Card from '@/components/Card';
import { renderPrice } from '@/utils/strings';
import { classes } from '@/components/InsightsCards/utils';

export type CurrentValueCardProps = {
  className?: string;
  currentValue: number;
};

export default function CurrentValueCard({
  className,
  currentValue,
}: CurrentValueCardProps) {
  return (
    <Card className={twMerge(classes.card, className)}>
      <div className={classes.textWrapper}>
        <div className={classes.label}>Current Value</div>
        <Title size="md">{renderPrice(currentValue, { concise: true })}</Title>
      </div>
      <div className={twMerge(classes.icon, classes.profitIcon)}>
        <ProfitIcon />
      </div>
    </Card>
  );
}
